import Login from './pages/Login.vue'
import Register from './pages/Register.vue'
import Password from './pages/Password.vue'

export default [
	{
		path: '/auth/login',
		name: 'login',
		component: Login
	},
	{
		path: '/auth/register',
		name: 'register',
		component: Register
	},
	{
		path: '/auth/password-reset',
		name: 'passwordResetStepOne',
		component: Password
	},
	{
		path: '/password-reset/:code',
		name: 'passwordResetStepTwo',
		component: Password
	},
	{
		path: '/activate-account/:code',
		name: 'activate',
		component: Login
	},
	{
		path: '/:pathMatch(.*)*',
		redirect: '/auth/login'
	}
]
